enum SubSites {
    current = '',
    home = '/',
    line = '/line/:id',
    newLine = '/line/new',
    route = '/route/:id',
    newRoute = '/route/new',
    routes = '/routes/',
    link = '/link/:id',
    splitLink = '/splitLink/:id',
    newLink = '/link/new/:id',
    routePath = '/routePath/:id',
    newRoutePath = '/routePath/new',
    routePathComparison = '/routePathComparison/:id',
    node = '/node/:id',
    newNode = '/node/new/:id',
    stopArea = '/stopArea/:id',
    newStopArea = '/stopArea/new',
    login = '/login',
    afterLogin = '/afterLogin',
}

export default SubSites;
